import { render, staticRenderFns } from "./nlp-analysis-tool-modal.html?vue&type=template&id=fce636fe&scoped=true&"
import script from "./nlp-analysis-tool-modal.js?vue&type=script&lang=js&"
export * from "./nlp-analysis-tool-modal.js?vue&type=script&lang=js&"
import style0 from "./nlp-analysis-tool-modal.scss?vue&type=style&index=0&id=fce636fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce636fe",
  null
  
)

export default component.exports